import { useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import type { HeaderContext } from '@tanstack/react-table';
import type { ProjectClips } from '@trinity/chat/types';
import { ProjectClipsFiltersContext } from '../../contexts/project-clips/Context';
import { FilterableHeader } from './FilterableHeader';

type Props = HeaderContext<ProjectClips.Item, unknown> & {
  /** Render function receiving a close callback. If omitted, the filter icon is hidden. */
  filterMenu?: (onClose: () => void) => ReactNode;
};

export const TagsHeader = ({ column, filterMenu }: Props) => {
  const filters = useContext(ProjectClipsFiltersContext);
  const isFilterActive = useMemo(() => !!filters.tagIds.length, [filters.tagIds]);

  return (
    <FilterableHeader columnId={column.id} filterMenu={filterMenu} isFilterActive={isFilterActive}>
      Tags
    </FilterableHeader>
  );
};

TagsHeader.displayName = 'ProjectClips.TagsHeader';
